<div class="file-selected-box">
    <header>
      <h3 [innerHTML]="title"></h3>
        <div *ngIf="buttonAction" class="file-selected-button">
          <span (click)="onButtonActionClick.emit($event)"><em>{{ buttonActionText }}</em></span>
        </div>
    </header>
    <!-- Default box -->
    <div [hidden]="files.length>0" class="file-unselected-name">
        <span><em>{{ boxDefaultText }}</em></span>
    </div>
    <!-- File item -->
    <div [hidden]="files.length==0"><!-- list container -->
      <ul>
        <li *ngFor="let file of files" class="file-selected-name">
          <span><em>{{file.name}}</em> <strong title="Close" (click)="onFileActionClick.emit(file)">{{fileActionText}}</strong></span>
        </li>
      </ul>
    </div>
</div>
